// Vars //
var $body = jQuery('body');

function navOnScroll() {
    var body = jQuery("body");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            body.addClass("scrolled");
        } else {
            body.removeClass("scrolled");
        }
    });
}

// Header Slider - Setup Function
function sliderSetup() {
    jQuery('.slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false,
            $auto = false;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }
        
        // AutoPlay //
        if ($container.hasClass('auto')) {
            $auto = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            fade: true,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplay: $auto,
            autoplaySpeed: 2500,
            speed: 1500,
            cssEase: 'linear',
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Product Slider
 * Used for multiple blocks - Feature Product Slider, Feature Category Product Slider
 * 
 */
function featureProductSliderSetup() {
    jQuery('.feature-product-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.feature-product-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            auto = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
            slidesToScroll = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Content Block Slider
 * 
 */
function contentBlockSliderSetup() {
    jQuery('.slider-content-block .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.slider-content-block');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            fade: true,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * SC Feature News Block
 * 
 */
function featureNewsBlockSliderSetup() {
    // jQuery('.feature-news-block-slider .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.feature-news-block-slider');
    $sliderContainer.each(function () {
            var $container = jQuery(this),
                $slider = $container.find('.slider'),
                $controls = $container.find('.slider-controls'),
                $dots = $container.find('.slider-dots'),
                dots = true,
                infinite = false
                ;

            // Dots //
            if ($container.hasClass('dots')) {
                dots = true;
            }

            // Infinite //
            if ($container.hasClass('infinite')) {
                infinite = true;
            }

            $slider.not('.slick-initialized').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: dots,
                fade: true,
                infinite: infinite,
                appendDots: $dots,
                appendArrows: $controls,
                prevArrow:
                    '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
                nextArrow:
                    '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>',
                // responsive: [
                //     {
                //       breakpoint: 992,
                //       settings: {
                //         slidesToShow: 1,
                //       }
                //     },
                // ],
            });
        });
}

/**
 * 
 * Feature News Block Slider
 * 
 */
function scFeatureNewsBlockSlider() {
    jQuery('.sc-feature-news-block-slider .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.sc-feature-news-block-slider');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = true,
            infinite = true,
            slidesToShow = 1;
            slidesToScroll = 1;

        if (jQuery(window).width() >= 1200 && jQuery(window).width() <= 1439) {
            if ($container.hasClass('page-has-sidebar')) {
                slidesToShow = 1;
                slidesToScroll = 1;
            } else {
                slidesToShow = 3;
                slidesToScroll = 1;
            }
        } else if (jQuery(window).width() > 767) {
            if ($container.hasClass('page-has-sidebar')) {
                slidesToShow = 1;
                slidesToScroll = 1;
            } else {
                slidesToShow = 2;
                slidesToScroll = 1;
            }

            centerMode = true;

        } else if (jQuery(window).width() <= 767) {
            if ($container.hasClass('page-has-sidebar')) {
                slidesToShow = 1;
                slidesToScroll = 1;
            } else {
                slidesToShow = 1;
                slidesToScroll = 1;
            }

            centerMode = true;
        } else {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Slide Show Gallery
 * 
 */
function scSlideShowGallery() {
    jQuery('.slide-show-gallery .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.slide-show-gallery');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 1;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

// Header Slider - Setup Function
function landingPageAnimation() {
    jQuery('.animated-circles .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.animated-circles');

    $sliderContainer.each(function () {
        var $container = jQuery(this);
        var $slider = $container.find('.slider');

        var $slideSpeed = 5000;

        $slider.on('init reInit', function (event, slick, currentSlide, nextSlide) {
            var slideCount = slick.slideCount - 1;

            console.log('Slide Count: ', slideCount);
        });

        $slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var slideCount = slick.slideCount - 1;

            console.log('Slide Count: ', slideCount, ', Current Slide: ', currentSlide);

            if (slideCount == currentSlide) {
                // $slider.fadeOut(1000);
                $slider.addClass('hidden-slider');
                $slider.slick('slickSetOption', 'speed', 0);
                $slider.slick('slickGoTo', 0);
            }

            if (currentSlide == 0) {
                // $slider.fadeIn(1000);
                $slider.removeClass('hidden-slider');
                $slider.slick('slickSetOption', 'speed', $slideSpeed);
            }
        });

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            speed: $slideSpeed,
            useTransform: true,
            vertical: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false
        });
    });
}

/**
 * 
 * Similar Resources Slider
 * Used on all Single Resource Pages
 * 
 */
function scSimilarResourceSlider() {
    jQuery('.similar-resources-slider .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.similar-resources-slider');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = true,
            infinite = true;

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

// Disclaimer Popup //
function disclaimerPopup() {
    var $body = jQuery('body');
    
    $disclaimerPopupBlock = $body.find('.disclaimer-popup-block');
    $disclaimerPopupBlockClose = $body.find('.disclaimer-popup-block__close');
    $disclaimerPopupBlockInner = $disclaimerPopupBlock.find('.disclaimer-popup-block__inner');
    $disclaimerPopupBlockAlternateButton = $disclaimerPopupBlockInner.find('a.js-disclaimer-popup-block');

    if ($disclaimerPopupBlock.hasClass('js-open')) {
        $disclaimerPopupBlock.removeClass('js-open');
        $disclaimerPopupBlockClose.removeClass('js-open');
        $disclaimerPopupBlockAlternateButton.removeClass('js-open');
    } else {
        $disclaimerPopupBlock.addClass('js-open');
        $disclaimerPopupBlockClose.addClass('js-open');
        $disclaimerPopupBlockAlternateButton.addClass('js-open');
    }
}

function disclaimerPopupClose() {
    var $body = jQuery('body');

    $disclaimerPopupBlock = $body.find('.disclaimer-popup-block');
    $disclaimerPopupBlockClose = $body.find('.disclaimer-popup-block__close');
    $disclaimerPopupBlockInner = $disclaimerPopupBlock.find('.disclaimer-popup-block__inner');
    $disclaimerPopupBlockAlternateButton = $disclaimerPopupBlockInner.find('a.js-disclaimer-popup-block');

    $disclaimerPopupBlock.removeClass('js-open');
    $disclaimerPopupBlockClose.removeClass('js-open');
    $disclaimerPopupBlockAlternateButton.removeClass('js-open');
}